import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import React from 'react';

const CheckoutForm = ({ successCB, loadingCB, failCB }) => {
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    loadingCB(true)
    const result = await stripe.confirmSetup({
      elements,
      redirect: "if_required"
    });

    if (result.error) {
      failCB(result.error);
    } else {
      successCB();
    }
    loadingCB(false)
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <button class="w-75 btn btn-primary StripeValidateBtn" disabled={!stripe}>Submit</button>
    </form>
  )
};

export default CheckoutForm